<template>
  <div class="products-listing--box skeleton-box">
    <div class="products-listing--box--cover skeleton">
      <div class="skeleton-image"></div>
    </div>

    <div class="products-listing--box--content">
      <div class="product-info">
        <div class="product-info--head">
          <div class="skeleton-title"></div>
          <div class="skeleton-subtitle"></div>
          <div class="skeleton-author"></div>
        </div>

        <div class="product-info--tags">
          <div class="skeleton-tag"></div>
        </div>

        <div class="product-info--description">
          <div class="skeleton-description"></div>
          <div class="skeleton-description short"></div>
        </div>

        <div class="product-info--footer">
          <div class="product-info--footer--box">
            <div class="skeleton-price"></div>
          </div>

          <div class="product-info--footer--box">
            <div class="skeleton-button"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductSkeleton'
}
</script>
